import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarDriverCertificationsQueryAtom = createQueryAtomFactory(
  'calendar.driverCertifications',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => ({
    driverCertifications: {
      __args: {
        filter: {
          fromExpirationDate: `${params.fromDate}T00:00:00Z`,
          toExpirationDate: `${params.toDate}T23:59:59Z`,
        },
        pagination: {
          limit: 500,
          offset: 0,
        },
      },
      entries: {
        id: true,
        driverId: true,
        type: true,
        number: true,
        issuedDate: true,
        expirationDate: true,
        issuingBody: true,
        driver: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
);
